/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { StubFileSystem };
class StubFileSystem {
    query() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    read() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    write() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    close() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    createRunFileSystem() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    createModuleFileSystem() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
    env() {
        throw new Error("Attempting to use stubbed-out file system.");
    }
}
//# sourceMappingURL=stub-file-system.js.map